<ng-container *ngIf="!avatar.isUnknown; else unknownAvatar">
  <y42-avatar
    *ngIf="avatar.imgSrc"
    [src]="avatar.imgSrc"
    size="30"
    class="cursor-pointer"
    [matTooltip]="avatar.full_name"
  >
  </y42-avatar>
  <y42-avatar
    *ngIf="!avatar.imgSrc"
    [name]="avatar.full_name"
    size="30"
    class="cursor-pointer"
    [matTooltip]="avatar.full_name"
  >
  </y42-avatar>
</ng-container>

<ng-template #unknownAvatar>
  <y42-avatar
    [name]="'?'"
    [bgColor]="'#DDDDDD'"
    size="30"
    class="unknown cursor-pointer"
    [matTooltip]="avatar.full_name"
  >
  </y42-avatar>
</ng-template>
